import { SubscriptionCancelled as SubscriptionCancelledComponent } from '@/components/SubscriptionCancelled';

const SubscriptionCancelled = () => {
  return <SubscriptionCancelledComponent />;
};

export default SubscriptionCancelled;